/* <!-- Legal templates pending review by qualified counsel before production --> */
import { HELP_EMAIL } from "@/constants/links";

import { LEGAL_LAST_UPDATED } from "./legalDate";
import LegalShell from "./LegalShell";

export default function Terms() {
    return (
        <LegalShell
            title="Terms of Service"
            lastUpdated={LEGAL_LAST_UPDATED}
            testId="terms-page"
        >
            <p className="core-legal-lede">
                These terms govern your use of C-ORE C-Suites, operated by
                Core Billion.
            </p>

            <section className="core-legal-section">
                <h2>Service usage</h2>
                <p>
                    C-ORE C-Suites provides business intelligence and
                    decision-support tools for registered businesses and
                    their authorised users. The insights provided are
                    advisory and are not a substitute for professional
                    accounting, tax, legal or financial advice.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>User responsibilities</h2>
                <p>
                    You are responsible for the accuracy of the data you
                    connect, for maintaining the confidentiality of your
                    login credentials, and for ensuring your use complies
                    with applicable law. You must not misuse the service,
                    attempt unauthorised access, or interfere with its
                    operation.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Subscription terms</h2>
                <p>
                    Plans are Monthly ($25/month), Professional ($249/year)
                    and Boardroom Pioneer (one-time $1,249, lifetime). A
                    1-month free trial is available. Fees are exclusive of
                    applicable taxes. Paid plans renew per their terms
                    until cancelled. You own your business data and may
                    export it before account closure; you grant Core
                    Billion a limited licence to process it solely to
                    provide the service.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Limitation of liability</h2>
                <p>
                    The service is provided on an &ldquo;as is&rdquo; and
                    &ldquo;as available&rdquo; basis. To the maximum extent
                    permitted by law, Core Billion's aggregate liability
                    arising from the service is limited to the fees you
                    paid in the twelve months preceding the claim. These
                    terms are governed by the laws of India.
                </p>
            </section>

            <section className="core-legal-section">
                <h2>Contact</h2>
                <p>
                    <a
                        href={`mailto:${HELP_EMAIL}`}
                        data-testid="terms-contact-email"
                    >
                        {HELP_EMAIL}
                    </a>
                </p>
            </section>
        </LegalShell>
    );
}
